import { render } from "./RocketCard.vue?vue&type=template&id=92da836e"
import script from "./RocketCard.vue?vue&type=script&lang=js"
export * from "./RocketCard.vue?vue&type=script&lang=js"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__